export default __webpack_public_path__ + "static/media/loading.aae1ba77.gif";